import React, { useState, useEffect } from 'react'
import LawyerMonthLogo from 'media-library/lawyer-month-logo.png'
import LawyerMonthDiscount from 'media-library/lawyer-month-discount.png'
import * as styles from './styles.module.scss'

export function Topbar({ link, messageBtn, messageBtnMobile = messageBtn }) {
	const [showTopbar, setShowTopbar] = useState(false)
	const STORAGE_INTERACT = 'interact_topbar:1.0.0'

	function sendGAEvent(type, evenName, tagGA4) {
		if (typeof window.gtag === 'function') {
			window.gtag('event', evenName, {
				event_type: type,
				non_interaction: true,
				send_to: tagGA4,
			})
		}
	}

	function handleTopbarClick() {
		if (typeof window !== 'undefined') {
			sessionStorage.setItem(STORAGE_INTERACT, 'true')
		}

		sendGAEvent('Click', 'SiteTopbarClickCta', 'G-V24Z24HJ0H')

		location.assign(link)
	}

	function secondsToShowTopbar(seconds = 0) {
		let time = seconds * 1000

		setTimeout(() => {
			if (typeof window != undefined) {
				const interact = JSON.parse(sessionStorage.getItem(STORAGE_INTERACT))
				let hasInteract = interact === true ?? false
				if (!hasInteract) {
					sendGAEvent('View', 'SiteTopbarOpen', 'G-V24Z24HJ0H')
					return setShowTopbar(true)
				}
			}
		}, time)
	}

	useEffect(() => {
		secondsToShowTopbar(2)
	}, [])

	return (
		showTopbar && (
			<div className={styles.topbar_lawyer_month} onClick={handleTopbarClick}>
				<div className={styles.lawyer_month_logos}>
					<img src={LawyerMonthLogo} className={styles.campaignLogo_img} />
					<img src={LawyerMonthDiscount} className={styles.discount_img} />
				</div>
				<div className={styles.message}>
					<span style={{ whiteSpace: 'nowrap' }}>
						Restam poucos cupons de 30% OFF no Astrea.
					</span>{' '}
					<span style={{ whiteSpace: 'nowrap' }}>
						Escolha mudar o seu futuro!
					</span>
				</div>

				<div className={styles.container_btn}>
					<a
						class={`for-desktop for-tablet ${styles.button}`}
						href="#"
						onClick={(e) => e.preventDefault()}
					>
						{messageBtn}
					</a>

					<a
						class={`for-mobile ${styles.button}`}
						href="#"
						onClick={(e) => e.preventDefault()}
					>
						{messageBtnMobile}
					</a>
				</div>
			</div>
		)
	)
}
